export const periodDictionary = {
  today: 'hoje',
  nextDay: 'amanhã',
  nextWeek: 'próximos 7 dias',
  nextMonth: 'próximos 30 dias',
} as const;
